<template>
  <div class="flex-wrap flex-line container align-stretch">
    <div style="width:160px;min-width:160px;border-right:1px solid var(--border);">
      <BaseMenu :menus="menus" :actived="actived" @on-click="handleOpen"></BaseMenu>
    </div>
    <div style="flex-grow:1;padding:0 5px;position:relative;overflow：hidden">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  routerOption: {
    as_frame: true,
    as_default: true,
    redirect: 'manage',
  },
  computed: {
    menus() {
      return [{
        name: '考核管理',
        key: 'manage',
        icon: 'organization',
      }, {
        name: '考核结果',
        key: 'list',
        icon: 'pm2',
      }];
    },
    actived() {
      return this.$route.path.slice(this.$route.path.lastIndexOf('/')+1);
    },
  },
  methods: {
    handleOpen(e) {
      this.RouteTo(e);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
